import { useTranslation } from 'react-i18next';
import { InstrumentListsIcon } from 'shared/assets/svg/menu-icons/InstrumentListsIcon';
import activityPanelStore from 'shared/store/activityPanelStore';
import { AddProductListModal } from './AddProductListModal';
import { ProductListDetailModal } from './ProductListDetailModal';

import styles from '../InstrumentListsPanel.module.scss';
import { FinecoButton } from 'pages/assistant/components/FinecoButton';

export const InstrumentListsPanelContent: React.FC = () => {
  const { t } = useTranslation();
  const productLists = activityPanelStore((state) => state.productLists);
  const fetchProductLists = activityPanelStore((state) => state.fetchProductLists);

  return (
    <div className={styles.contentContainer}>
      {productLists.length === 0 ? (
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>
            <InstrumentListsIcon size={48} />
          </div>
          <div className={styles.emptyStateTitle}>{t('instrumentLists.emptyState')}</div>
          <div className={styles.emptyStateDescription}>{t('instrumentLists.emptyStateDescription')}</div>
        </div>
      ) : (
        <div className={styles.listContainer}>
          {productLists.map((list) => (
            <ProductListDetailModal key={list.id} list={list}>
              <div className={styles.listItem}>
                <span className={styles.listItemText}>{list.name}</span>
              </div>
            </ProductListDetailModal>
          ))}
        </div>
      )}

      <div className={styles.addButtonContainer}>
        <AddProductListModal onSuccess={fetchProductLists}>
          <FinecoButton className={styles.addButton} click={() => {}} copy={t('instrumentLists.addList')} />
        </AddProductListModal>
      </div>
    </div>
  );
};
